<template>
  <div>
    <!-- Price Title -->
    <h4 class="h5 fw-bold mb-3">
      {{ $t(`project.previewAndReport.reportTypes.${reportType}.price.title`) }}
    </h4>

    <!-- Total Price Section -->
    <div
      style="
        background-color: #ebfff2;
        padding: 20px;
        margin-bottom: 20px;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-height: 120px;
      "
    >
      <div class="text-start" style="margin: 0">
        <p style="font-size: 20px; margin: 0 0 6px 0;">
          <span v-html="
            $t(
              `project.previewAndReport.reportTypes.${reportType}.price.totalPrice`,
              {
                price: ` <span style='color: var(--description-color);'>${new Intl.NumberFormat('en-EU', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(projectData?.financial_data?.final_price || 0)}</span>`,
                IVApercentage: reportType && reportType.startsWith('complete_solution') ? '10%' : '',
              }
            )
          "></span>
        </p>
        <p
          style="font-size: 12px; margin: 0"
          v-html="
            $t(
              `project.previewAndReport.reportTypes.${reportType}.price.financingNote`,
              {
                years: Math.round(
                  (projectData?.financial_data?.installment_duration_months ||
                    120) / 12
                ),
              }
            )
          "
        ></p>
      </div>
    </div>

    <!-- Total Financed Section 
    <div
      v-if="paymentType === 'installment'"
      style="
        background-color: #ebfff2;
        padding: 20px;
        margin-bottom: 40px;
        border-radius: 4px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
        display: flex;
        align-items: center;
        justify-content: flex-start;
        min-height: 100px;
      "
    >
      <div class="text-start" style="margin: 0">
        <p style="font-size: 20px; margin: 0">
          {{
            $t(
              `project.previewAndReport.reportTypes.${reportType}.price.financedAmount`,
              {
                amount: new Intl.NumberFormat("en-EU", {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(
                  (projectData?.financial_data?.installment_amount || 0) *
                    (projectData?.financial_data?.installment_duration_months ||
                      120)
                ),
              }
            )
          }}
        </p>
      </div>
    </div>
    -->
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import type { Project } from "@/types/projectTypes";

export default defineComponent({
  name: "PriceSection",
  props: {
    projectData: {
      type: Object as PropType<Project | null>,
      required: true,
    },
    paymentType: {
      type: String,
      required: true,
    },
    reportType: {
      type: String,
      required: true,
    },
  },
});
</script>
